import React from "react";
import { Grid, Box, Typography, Card } from "@mui/material";
import InvoicesProcessingAcceptedVs from "../../components/PieCharts/InvoicesProcessingAcceptedVs";
import PaymentsPieVs from "../../components/PieCharts/PaymentsPieVs";
import MonthlyPayments from "../../components/BarCharts/MonthlyPayments";
import PendingPayments from "../tables/PendingPayments";
import StudentsByCourse from "../../components/BarCharts/StudentsByCourse";

const AdminDashboard = () => {
  return (
    <Box
      sx={{
        p: { xs: 0, sm: 2 },
        m: { xs: 0, sm: 2 },
      }}
    >
      <Typography variant="h1" sx={{ ml: 2 }}>
        Dashboard
      </Typography>
      <Grid container spacing={2}>
        {/* Card 1 and Card 2 - Monthly Payments and Pending Payments */}
        <Grid item xs={12} lg={6}>
          <Card
            variant="outlined"
            sx={{ display: "flex", flexDirection: "column" }}
          >
            <MonthlyPayments />
          </Card>
        </Grid>

        <Grid item xs={12} lg={6}>
          <Card
            variant="outlined"
            sx={{ display: "flex", flexDirection: "column" }}
          >
            <StudentsByCourse />
          </Card>
        </Grid>

        {/* Card 3 - Students by Course (Bar Chart) */}
        <Grid item xs={12} lg={12}>
          <PendingPayments />
        </Grid>

        {/* Card 4 - Invoices Processing and Payments Pie (Pie Charts) */}
        <Grid item xs={12} lg={6}>
          <Card
            variant="outlined"
            sx={{ display: "flex", flexDirection: "column" }}
          >
            <Typography sx={{ fontWeight: "bold", mb: 2, p: 2 }}>
              Status de pagos
            </Typography>
            <Box sx={{ p: 2 }}>
              <InvoicesProcessingAcceptedVs />
            </Box>
          </Card>
        </Grid>

        <Grid item xs={12} lg={6}>
          <Card
            variant="outlined"
            sx={{ display: "flex", flexDirection: "column" }}
          >
            <Typography sx={{ fontWeight: "bold", mb: 2, p: 2 }}>
              Vs de métodos de pago
            </Typography>
            <Box sx={{ p: 2 }}>
              <PaymentsPieVs />
            </Box>
          </Card>
        </Grid>
      </Grid>
    </Box>
  );
};

export default AdminDashboard;
